<template>
  <div>
    <div class="flex border-b border-dark-b">
      <h2 class="text-xl md:text-2xl font-medium mr-6">My Addresses</h2>
    </div>
    <div class="py-7.5 grid md:grid-cols-2 lg:grid-cols-3 gap-4 xl:gap-10">
      <div
        v-for="(address, index) in addresses"
        :key="`my-address-${index}`"
        class="p-7.5 bg-white border border-dark-b rounded-lg"
      >
        <AddressBox
          :address="address"
          @edit="editAddress"
          @delete="deleteAddress"
        />
      </div>
      <button
        class="bg-white border border-dark-b rounded-lg flex items-center justify-center py-32"
        @click="addNewAddress"
      >
        <div class="leading-6 text-blue font-medium text-xl">
          <p>+</p>
          <p>Add New</p>
          <p>Address</p>
        </div>
      </button>
    </div>
    <AddressFormModal
      v-if="showAddressModal"
      :isEditing="isEditing"
      :address="addressToEdit"
      @close="closeAddressModal"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import AddressBox from '@/shared/components/profile/address/AddressBox'
import AddressFormModal from '@/shared/components/profile/address/AddressFormModal'


export default {
  name: 'MyAddresses',
  components: {
    AddressFormModal,
    AddressBox
  },
  data() {
    return {
      addresses: [],
      showAddressModal: false,
      isEditing: false,
      addressToEdit: null
    }
  },
  async created() {
    this.addresses = await this.fetchBuyerAddresses()
  },
  computed: {
    ...mapGetters ([
      'getUserAuthInfo'
    ])
  },
  methods: {
    ...mapActions ([
      'fetchBuyerAddresses',
      'deleteBuyerAddress'
    ]),
    addNewAddress() {
      this.addressToEdit = null
      this.isEditing = false
      this.showAddressModal = true
    },
    editAddress(address) {
      this.addressToEdit = {...address}
      this.isEditing = true
      this.showAddressModal = true
    },
    async deleteAddress(address) {
      const response = await this.deleteBuyerAddress(address.id_token)
      this.addresses = await this.fetchBuyerAddresses()
      this.$notify({
        group: 'buyHive',
        type: response.result ? 'success' : 'error',
        text: response.message
      })
    },
    async closeAddressModal(done) {
      this.showAddressModal = false
      if (done) {
        this.addresses = await this.fetchBuyerAddresses()
      }
    }
  }
}
</script>
